const statusPresentation = {
  published: { label: "منتشر شده", tone: "success" },
  draft: { label: "پیش‌نویس", tone: "warning" },
  disabled: { label: "غیرفعال", tone: "neutral" },
};

export const getMenuOverviewPath = (menuId) => (
  menuId ? `/dashboard/menu?menuId=${encodeURIComponent(menuId)}` : "/dashboard/menu"
);

export const getMenuStatusMeta = (status) => ({
  status,
  ...(statusPresentation[status] || {
    label: "وضعیت نامشخص",
    tone: "neutral",
  }),
});

const lifecycleStatus = (menu) => (
  menu?.status || (menu?.isActive ? "published" : "disabled")
);

export const applyMenuStatusChange = (menus, updatedMenu) => {
  const safeMenus = Array.isArray(menus) ? menus : [];
  if (!updatedMenu?._id) return safeMenus;

  return safeMenus.map((menu) => {
    if (String(menu?._id) === String(updatedMenu._id)) return updatedMenu;
    if (lifecycleStatus(updatedMenu) === "published" && lifecycleStatus(menu) === "published") {
      return { ...menu, status: "disabled", isActive: false };
    }
    return menu;
  });
};

const lastUpdatedAt = (menu) => {
  const time = new Date(menu?.updatedAt || 0).getTime();
  return Number.isFinite(time) ? time : 0;
};

const selectMenu = (menus, preferredMenuId) => {
  const preferred = preferredMenuId
    ? menus.find((menu) => String(menu?._id) === String(preferredMenuId))
    : null;
  if (preferred) return preferred;

  const published = menus.find((menu) => lifecycleStatus(menu) === "published");
  if (published) return published;

  return [...menus].sort((first, second) => lastUpdatedAt(second) - lastUpdatedAt(first))[0] || null;
};

const emptyOverview = () => ({
  hasMenu: false,
  menuCount: 0,
  menu: null,
  menuId: null,
  title: null,
  status: null,
  statusLabel: null,
  isPublished: false,
  updatedAt: null,
  counts: {
    categories: 0,
    items: 0,
    missingImages: 0,
    incompleteItems: 0,
  },
});

const itemIsIncomplete = (item) => {
  const nameMissing = !String(item?.name || "").trim();
  const priceMissing = item?.price === null
    || item?.price === undefined
    || String(item.price).trim() === ""
    || !Number.isFinite(Number(item.price));
  return nameMissing || priceMissing;
};

export const buildMenuOverview = ({ menus, preferredMenuId } = {}) => {
  const safeMenus = Array.isArray(menus) ? menus : [];
  const menu = selectMenu(safeMenus, preferredMenuId);
  if (!menu) return emptyOverview();

  const categories = Array.isArray(menu.categories) ? menu.categories : [];
  const items = categories.flatMap((category) => (
    Array.isArray(category?.items) ? category.items : []
  ));
  const status = lifecycleStatus(menu);
  const statusMeta = getMenuStatusMeta(status);

  return {
    hasMenu: true,
    menuCount: safeMenus.length,
    menu,
    menuId: menu._id || null,
    title: menu.title || "منوی رستوران",
    status,
    statusLabel: statusMeta.label,
    isPublished: status === "published",
    updatedAt: menu.updatedAt || null,
    counts: {
      categories: categories.length,
      items: items.length,
      missingImages: items.filter((item) => !String(item?.image || "").trim()).length,
      incompleteItems: items.filter(itemIsIncomplete).length,
    },
  };
};
